import React, {PropsWithChildren} from "react";
import "./Button.css";

interface Props {
  active?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  emphasized?: boolean;
  className?: string;
  title?: string;
  type?: "button" | "submit" | "reset";
}

export const Button = ({
                         onClick,
                         active = false,
                         disabled = false,
                         emphasized = false,
                         className = "",
                         title = "",
                         type = "button",
                         children
                       }: PropsWithChildren<Props>) => {

  function handleClick() {
    if (onClick) {
      onClick()
    }
  }

  let classNames = className + " lcd-button";
  if (active) {
    classNames += " active";
  } else if (emphasized) {
    classNames += " emphasized";
  }

  return (
      <button
          title={title}
          className={classNames}
          disabled={disabled}
          onClick={handleClick}
          type={type}
      >
        {children}
      </button>
  );
}